import React, { useEffect } from 'react';

import RecordAlt from 'svg/record-alt';

/**
 * The Recorder
 *
 * Records the bops
 */
const Recorder = (props) => {
  /**
   * Record using the main controller record function,
   * setting the recording and isRecording states
   */
  useEffect(() => {
    props.controller.record(props.setIsPlaying, props.setRecording, props.setIsRecording, props.setShowDownload);
    // eslint-disable-next-line
  }, []);
  return (
    <article className='Main-overlay Recorder'>
      <section className='Main-overlay__inner'>
        <h1 className='button'>Generating Loop</h1>
        <RecordAlt className='Recorder__icon' title='Recording Timer' />
      </section>
    </article>
  );
};

export default Recorder;

